module.exports = __webpack_public_path__ + "img/regionalCase_bg_6_1.d6f71d05.jpg";